var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui container"},[_vm._v(" Instructors ")])
}
var staticRenderFns = []

export { render, staticRenderFns }